import {
    FETCH_LATEST_UNIT_BEGIN,
    FETCH_LATEST_UNIT_SUCCESS,
    UPDATE_LATEST_UNIT_PAGE
} from '../actions/latestUnitActions';

const initialState = {
    units: [],
    pagination: {
        page_limit: 0,
        total_pages: 0,
        total_records: 0,
        current_page: 0,
    },
    loading: false,
    error: null
};

export default function latestUnitReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_LATEST_UNIT_BEGIN:
            return {
                ...state,
                loading: true,
                error: null,
                pagination: {
                    ...state.pagination,
                    current_page: action.payload
                }
            };

        case FETCH_LATEST_UNIT_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.payload.result
            };
        case UPDATE_LATEST_UNIT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };

        default:
            return state;
    }
}